import {
  ru,
  kk,
  uz,
  be,
} from 'date-fns/locale'

const getDateFnsLocaleByIso = (iso: string) => {
  const locales = {
    ru,
    kk,
    uz,
    be,
  }

  if (iso in locales) {
    return locales[iso as keyof typeof locales]
  }

  return ru
}

export default getDateFnsLocaleByIso
